import React, { useState } from "react";
import { useNavigate } from "react-router";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import Moment from "react-moment";
import Box from "@mui/material/Box";

export default function AcquisitionTable({ acquisitions, meta, setMeta }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const acquisitionDetail = (id) => {
    navigate(`/management/acquisitions/${id}`);
  };

  const asText = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || value?.description || String(value?.id || '-');
    }
    const str = String(value);
    return str?.trim?.() ? str : '-';
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <TableContainer className={"box-shadow"} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ color: "#B3B3B3", width: 20 }}>
                Sl.No
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Acquisition Date
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Acquisition Type
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Received From
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Permanent Address
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Appraised Value (Nu.)
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Price (Nu.)
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Storage
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {acquisitions?.length > 0 &&
              acquisitions?.map((acquisition, index) => (
                <TableRow hover key={index}>
                  <TableCell
                    align="left"
                    sx={{ color: "#3D3D3D", width: 20 }}
                    onClick={() => acquisitionDetail(acquisition?.id)}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell sx={{ color: "#3D3D3D" }} onClick={() => acquisitionDetail(acquisition?.id)}>
                    <Moment format={"ll"}>{acquisition?.date_of_entry || "-"}</Moment>
                  </TableCell>
                  <TableCell
                    className={"text-capitalize"}
                    sx={{ color: "#3D3D3D" }}
                    onClick={() => acquisitionDetail(acquisition?.id)}
                  >
                    {asText(acquisition?.acquisition_type || acquisition?.acquisition_type_legacy)}
                  </TableCell>
                  <TableCell sx={{ color: "#3D3D3D" }} onClick={() => acquisitionDetail(acquisition?.id)}>
                    {acquisition?.received_from}
                  </TableCell>
                  <TableCell sx={{ color: "#3D3D3D" }} onClick={() => acquisitionDetail(acquisition?.id)}>
                    {acquisition?.permanent_address}
                  </TableCell>
                  <TableCell sx={{ color: "#3D3D3D" }} onClick={() => acquisitionDetail(acquisition?.id)}>
                    {acquisition?.appraised_value}
                  </TableCell>
                  <TableCell sx={{ color: "#3D3D3D" }} onClick={() => acquisitionDetail(acquisition?.id)}>
                    {acquisition?.price}
                  </TableCell>
                  <TableCell sx={{ color: "#3D3D3D" }} onClick={() => acquisitionDetail(acquisition?.id)}>
                    {acquisition?.storage}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}
